/* eslint-disable @typescript-eslint/no-explicit-any */
import { Environment } from '@/domainLogic/index.ts';
import fetchWithRetry from './fetchWithRetry';

type SendEvents = {
  environment: Environment;
  isServer: boolean;
  data: any;
  AbortController: any;
  isBot: boolean;
};

type AnalyticsEndpoints = {
  qa: string;
  prod: string;
};

type GetEndpoint = {
  environment: Environment;
  isServer: boolean;
};

export const analyticsEndpointsIntra = {
  qa: `http://oss-balancer.prd.bravofly.intra/oss-evo/curiosity-qa`,
  prod: `http://oss-balancer.prd.bravofly.intra/oss-evo/curiosity`,
} as AnalyticsEndpoints;

export const analyticsEndpoints = {
  qa: `https://services.lastminute.com/oss-evo/curiosity-qa`,
  prod: `https://services.lastminute.com/oss-evo/curiosity`,
} as AnalyticsEndpoints;

const getEndpoint = ({ environment, isServer }: GetEndpoint): string => {
  if (environment !== Environment.PROD) {
    return isServer ? analyticsEndpoints.qa : analyticsEndpoints.qa;
  }
  return isServer ? analyticsEndpointsIntra.prod : analyticsEndpoints.prod;
};

export const sendEvent = ({ environment, isServer, data, AbortController, isBot }: SendEvents): Promise<any> => {
  if (isBot) {
    return Promise.resolve();
  }
  const url = getEndpoint({ environment, isServer });
  return fetchWithRetry({
    url,
    options: {
      method: 'POST',
      mode: 'cors',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
      body: JSON.stringify(data),
    },
    tm: 5000,
    AbortController,
    retry: 0,
  });
};

export const sendAsyncEvent = async ({
  environment,
  isServer,
  data,
  AbortController,
  isBot,
}: SendEvents): Promise<any> => {
  if (isBot) {
    return Promise.resolve();
  }
  const url = getEndpoint({ environment, isServer });
  return fetchWithRetry({
    url,
    options: {
      method: 'POST',
      mode: 'cors',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
      body: JSON.stringify(data),
    },
    tm: 5000,
    AbortController,
    retry: 0,
  });
};
